export default function QrTable({ datas = [], loading = false, handlerowClick }) {
    return (
        <div className="bg-surface rounded-lg border-minimal overflow-x-auto">
            <table className="w-full text-center qrdata">
                <thead className="bg-gray-50 border-b border-border">
                    <tr>
                        <th>Batch Code</th>
                        <th>Batch Name</th>
                        <th>Qrcode Unique No.</th>
                        <th>Company Name</th>
                        <th>Successful Scans</th>
                        <th>Failed Attempts</th>
                        <th>Total Attempts</th>
                    </tr>
                </thead>
                <tbody>
                    {loading ? (
                        <tr><td colSpan="7" className="p-4 text-center">Loading...</td></tr>
                    ) : datas.length === 0 ? (
                        <tr><td colSpan="7" className="p-4 text-center">No records Found</td></tr>
                    ) : datas.map((data) => {
                        const successful = data.successfulScans ?? data.scanCount ?? 0;
                        const failed = data.failedAttempts ?? 0;
                        const total = data.totalAttempts ?? successful + failed;
                        return (
                            <tr key={data.id} className="border-t cursor-pointer" onClick={() => handlerowClick(data.unique_no)}>
                                <td>{data.batch_code}</td>
                                <td>{data.batch_name || "N/A"}</td>
                                <td>{data.unique_no}</td>
                                <td>{data.company_name || "N/A"}</td>
                                <td className="text-green-600">{successful}</td>
                                <td className={failed > 0 ? 'text-red-600 font-semibold' : ''}>{failed}</td>
                                <td>{total}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}
